/**
 * 2020年12月16日 10:09:45
 * author:Ljj
 * 统一处理所有与原生相关的交互
 * 基本弃用
 */
function getNativeDeviceInfo() {
    var deviceInfo;
    //iOS
    try {
        window.webkit.messageHandlers.TXDeviceInfo.postMessage();
    } catch (e) {

    }
    try {
        ITXGoodSDK.getDeviceParams();
    } catch (e) {

    }
    return deviceInfo;
}

function nativePay(payInfo) {
    //iOS
    try {
        window.webkit.messageHandlers.TXAction.postMessage(JSON.stringify(payInfo));
    } catch (e) {

    }
    //android
    try {
        ITXGoodSDK.test("ITXCallBack");
        // ITXGoodSDK.pay(JSON.stringify(payInfo));
    } catch (e) {

    }
}

//由于iOS不能缓存，因此需要将登录结果交给iOS
function iOSLoginCallBack(data){
    try {
        window.webkit.messageHandlers.TXLoginAction.postMessage(data);
    } catch (e) {

    }
}
function getIOSLoginHistory(){
    try {
        window.webkit.messageHandlers.TXGetLoginHistory.postMessage("1");
    } catch (e) {

    }
}

function nativeCall(data) {
    console.log("接收到原生消息：" + JSON.stringify(data));
    var obj = {};
    if (typeof (data) == "object") {
        obj = data;
    } else {
        obj = JSON.parse(data);
    }

    if (obj.type === "device_info") {
        window.itx_device_info = obj.data;
    }
    if(obj.type ==="login_history"){
        window.itx_ios_login_history = obj.data;
    }
}

//获取设备信息
getNativeDeviceInfo();
getIOSLoginHistory();

export default {
    getNativeDeviceInfo, nativePay, nativeCall,iOSLoginCallBack
}


// WEBPACK FOOTER //
// ./src/common/native-bridge.js